import { PlusIcon } from '@heroicons/react/20/solid';
import Page from '../../../components/PageWrapper';
import { useEffect, useMemo, useState } from 'react';
import { getAllVehicles } from '../../../api/requests';
import Loader from '../../../components/Loader';
import GTable from '../../../components/elements/GTable';
import Button from '../../../components/form-control/Button';
import AddVehicle from './AddVehicle';
import { Vehicle } from '../../../models/vehicle/Vehicle';
import { ITablePaginationData } from '../../../components/elements/GTable/GTable';
import useModal from '../../../hooks/modalHook';
import useVehicle from '../../../hooks/vehicleHook';

interface VehiclesProps {
  isSettings?: boolean;
}

const Vehicles = ({ isSettings = false }: VehiclesProps): JSX.Element => {
  const [vehicles, setVehicles] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [searchString, setSearchString] = useState<string>('');
  const [vehiclesPaginationData, setVehiclesPaginationData] = useState<ITablePaginationData>();
  const [showPerPage, setShowPerPage] = useState<number>(100);
  const { ModalComponent, updateModalStates, closeModal } = useModal();
  const { addVehicle, VehicleModal } = useVehicle();

  useEffect(() => {
    setLoading(true);
    getVehicles();
  }, []);

  useEffect(() => {
    getVehicles(0);
  }, [showPerPage]);

  const getVehicles = (page = 0) => {
    getAllVehicles(page, showPerPage)
      .then((response: any) => {
        setLoading(true);

        setVehicles(response?.data?.data);
        const from = response.pageable.offset + 1;
        const to =
          from + response.size > response.totalElements
            ? response.totalElements
            : from + response.size - 1;

        setVehiclesPaginationData({
          per_page: response.size,
          total: response.totalElements,
          totalPages: response.totalPages,
          from: from,
          to: to
        });
      })

      .catch((error: Error) => { })
      .finally(() => {
        setLoading(false);
      });
  };

  const columns = useMemo(
    () => [
      {
        Header: 'M',
        columns: [
          {
            Header: 'Vehicle Make ',
            accessor: 'maker',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },

          {
            Header: 'Model',
            accessor: 'model',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Cubic Capacity',
            accessor: 'cc',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Max Seat',
            accessor: 'maxSeat',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Min. Seat',
            accessor: 'miniSeat',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          },
          {
            Header: 'Latest model year',
            accessor: 'yearIssued',
            Cell: (row: any) => {
              return <span>{row.cell.value ? row.cell.value : '-'}</span>;
            }
          }
        ]
      }
    ],
    []
  );

  const handlePageChange = (page: number) => {
    getVehicles(page);
  };

  return (
    <Page title="Vehicles">
      <div className="bg-white dark:bg-darkBg p-5 min-h-full">

        {!isSettings &&
          <div className="flex items-center justify-between">
            <div className=" flex justify-end items-center">
              <div className=" flex gap-4">
                <div className="">
                  <Button
                    icon={<PlusIcon width="20px" height="20px" className="mr-2" />}
                    className="px-[18px] py-[12px] h-[45px] rounded"
                    bgColor="primary"
                    label="Add Vehicle"
                    onClick={addVehicle}
                  />
                </div>
              </div>
            </div>
          </div>
        }

        <div className=" w-full overflow-x-auto mt-4">
            <GTable
              selectionChanged={(selection: any) => { }}
              columns={columns}
              data={vehicles && vehicles?.filter((vehicles: Vehicle) =>
                vehicles?.model?.toLowerCase().includes(searchString)
              )}
              onSearch={(searchString: string) => setSearchString(searchString)}
              isRowLinked={false}
              searchPlaceholder={'Search by vehicle make...'}
              tableType={'vehicles'}
              onPageChange={handlePageChange}
              showPerPage={showPerPage}
              onShowPerPageChange={(page: number) => setShowPerPage(page)}
              loading={loading}
              classes={'max-h-[400px]'}
              stickyHeader
            />
          </div>
      </div>
      <ModalComponent />
      <VehicleModal />
    </Page>
  );
};

export default Vehicles;
